/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusreview2Inputs */

const en_crosspostingstatusreview2 = /** @type {(inputs: Crosspostingstatusreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In review`)
};

const de_crosspostingstatusreview2 = /** @type {(inputs: Crosspostingstatusreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Prüfung`)
};

/**
* | output |
* | --- |
* | "In review" |
*
* @param {Crosspostingstatusreview2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusreview2 = /** @type {((inputs?: Crosspostingstatusreview2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusreview2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusreview2(inputs)
	return de_crosspostingstatusreview2(inputs)
});
export { crosspostingstatusreview2 as "crosspostingStatusReview" }